import React, { Children, ReactElement, ReactNode, useEffect, useState } from "react";
import { Flex } from "@mantine/core";

interface IFoldableSectionCompound {
  Header: typeof FoldableSectionHeader;
  Body: typeof FoldableSectionBody;
}

const FoldableSection: React.FC<{ folded?: boolean; headerClick?: boolean }> & IFoldableSectionCompound = ({
  children,
  folded = false,
  headerClick = false,
  ...props
}) => {
  const [collapsed, setCollapsed] = useState<boolean>(folded);
  const [removedOverflow, setRemovedOverflow] = useState<boolean>(false);

  const [headerElement, setHeaderElement] = useState<ReactNode>(children[0]);
  const [bodyElement, setBodyElement] = useState<ReactNode>(children[1]);

  useEffect(() => {
    Children.forEach(children, (child: ReactElement) => {
      if (child.type === FoldableSectionHeader) {
        setHeaderElement(child);
      }
      if (child.type === FoldableSectionBody) {
        setBodyElement(child);
      }
    });
  }, [children]);

  useEffect(() => {
    setCollapsed(folded);
  }, [folded]);

  useEffect(() => {
    if (!collapsed) {
      const delayedOverflow = setTimeout(() => setRemovedOverflow(true), 400);
      return () => clearTimeout(delayedOverflow);
    } else setRemovedOverflow(false);
  }, [collapsed]);

  const handleHeaderClick = () => {
    if (headerClick) {
      setCollapsed(!collapsed);
    }
  };

  return (
    <Flex {...props} style={{ width: "100%" }}>
      <div
        onClick={() => setCollapsed(!collapsed)}
        className={`expandIcon${collapsed === true ? "" : " rotateIcon"}`}
        style={{ minWidth: "2rem", minHeight: "2rem", margin: "4px 4px 6px 0px" }}
      >
        <i className="fa fa-angle-down"></i>
      </div>
      <Flex direction="column" w="100%">
        <div
          className={headerClick ? "pointer" : ""}
          style={{ marginTop: "0.5rem" }}
          onClick={() => handleHeaderClick()}
        >
          {headerElement}
        </div>
        <div
          style={{
            display: "flex",
            ...(collapsed === true
              ? { height: 0, overflow: "hidden", width: "100%" /* transition: "height 0.4s ease-in-out" */ }
              : {
                  width: "100%",
                  /*height  transition: "height 0.4s ease-in-out" */
                }),
          }}
          className={removedOverflow === true ? "" : "overflow-hidden"}
        >
          {bodyElement}
        </div>
      </Flex>
    </Flex>
  );
};

const FoldableSectionHeader: React.FC = ({ children }) => {
  return <>{children}</>;
};

const FoldableSectionBody: React.FC = ({ children }) => {
  return <>{children}</>;
};

FoldableSection.Header = FoldableSectionHeader;
FoldableSection.Body = FoldableSectionBody;

export default FoldableSection;
